module.exports = __webpack_public_path__ + "img/alarm_bg.c63c7584.png";